import { ImageFill } from '@lyearn/icons';
import { isValidSubmission } from '@/modules/corporate/modules/questions/fields/single-select/utils';
import { QuizViewField } from '@/modules/corporate/modules/questions/fields/types';
import { QuestionSubTypeEnum, QuestionTypeEnum } from '@/types/schema';

import Player from '../../../components/Player';
import QuestionReview from '../../../components/QuestionReview';
import { getQuestionEvaluation } from '../../../utils';

const PictureChoiceViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission,
  Player,
  type: QuestionTypeEnum.PictureMultipleChoiceQuestion,
  getQuestionLabel: ({ questionSubType }) =>
    questionSubType === QuestionSubTypeEnum.MultiSelect
      ? 'QuizPlayer:MultiSelect'
      : 'QuizPlayer:SingleSelect',
  labelKey: 'QuizPlayer:QuestionType.PictureChoice',
  Icon: ImageFill,
  Review: QuestionReview,
  getShouldAutoAdvance: (question) => question.subType !== QuestionSubTypeEnum.MultiSelect,
};

export default PictureChoiceViewField;
